import { z } from "zod";
import { CardView } from "./card.js";
import { GroupEventView } from "./inbox.js";
import { TastingShareView } from "./tastingShare.js";

/**
 * One entry of the activity list: a friend's or group's card, a line of a group's log, or a tasting
 * a friend chose to share. The last is only sent to a client that asked for it (`?shared=1`),
 * because a bundle from before it parses the list strictly and would reject a kind it never heard of.
 */
export const ActivityItem = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("card"),
    id: z.string().min(1),
    at: z.iso.datetime(),
    card: CardView,
  }),
  z.object({
    type: z.literal("group_event"),
    id: z.string().min(1),
    at: z.iso.datetime(),
    group: z.object({ id: z.string().min(1), name: z.string() }),
    event: GroupEventView,
  }),
  z.object({
    type: z.literal("tasting_shared"),
    id: z.string().min(1),
    at: z.iso.datetime(),
    share: TastingShareView,
  }),
]);
export type ActivityItem = z.infer<typeof ActivityItem>;

/** GET /v1/activity -- newest first, cursor-paged. */
export const ActivityList = z.object({
  items: z.array(ActivityItem),
  nextCursor: z.string().nullable(),
});
export type ActivityList = z.infer<typeof ActivityList>;
